import { PopoverMenuComponent } from 'commons/components';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { useTranslation } from 'core/i18n/i18n';
import {
    OperatorCustomNotificationAction,
    OperatorCustomNotificationRow,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';
import { OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';

const ROW_ACTIONS_I18N_PREFIX = `${OPERATOR_CUSTOM_NOTIFICATIONS_I18N_PREFIX}.bulk-actions.actions`;

export interface OperatorCustomNotificationRowOptionsComponentProps {
    notification: OperatorCustomNotificationRow;
    onRequestAction: (action: OperatorCustomNotificationAction, notification: OperatorCustomNotificationRow) => void;
}

export const OperatorCustomNotificationRowOptionsComponent: React.FC<
    OperatorCustomNotificationRowOptionsComponentProps
> = ({ notification, onRequestAction }) => {
    const { t } = useTranslation();

    const anchor = `operator-custom-notification-row-options-${notification.id}`;
    const activationAction = notification.active ? 'deactivate' : 'activate';
    const activationIcon = notification.active ? 'circle_remove' : 'circle_on_off';

    return (
        <PopoverMenuComponent anchor={anchor}>
            <PocListItem onClick={() => onRequestAction(activationAction, notification)}>
                <PocIcon slot="prefix" name={activationIcon} family="outlined" />
                {t(`${ROW_ACTIONS_I18N_PREFIX}.${activationAction}`)}
            </PocListItem>
            <PocListItem onClick={() => onRequestAction('delete', notification)}>
                <PocIcon slot="prefix" name="delete" family="outlined" />
                {t(`${ROW_ACTIONS_I18N_PREFIX}.delete`)}
            </PocListItem>
        </PopoverMenuComponent>
    );
};
